/*
 * Product card color swatches (snippets/collection-grid-swatches.liquid).
 * Clicking a swatch swaps its card to that color in place: images, title, links, price overlay and
 * the inline quick-add sizes. Delegated, so cards added later by infinite scroll work too.
 * Handles both card types: collection pages (collection-grid-toggle) and the home page grid
 * (product-grid-item via featured-collection).
 */
(function () {
  'use strict';
  if (window.__cgtSwatches) return;
  window.__cgtSwatches = true;

  var WIDTHS = [180, 360, 540, 720, 900, 1080];

  // Order matters: collection-grid-toggle cards also carry the grid-product class.
  var CARDS = [
    {
      card: '.collection-grid-toggle__item',
      images: '.collection-grid-toggle__image-wrapper img.collection-grid-toggle__image',
      title: '.collection-grid-toggle__product-title',
      links: 'a.collection-grid-toggle__link, a.collection-grid-toggle__meta-link',
      overlay: '.collection-grid-toggle__price-overlay'
    },
    {
      card: '.grid__item.grid-product',
      images: '.grid-product__image-mask img',
      title: '.grid-product__title',
      links: 'a.grid-product__link, a.grid-product__title-link, a.grid-product__price-link, a.grid-product__notify-link',
      overlay: '.grid-product__price-overlay'
    }
  ];

  function sized(url, width) {
    return url.replace(/([?&])width=\d+/, '$1width=' + width);
  }

  function srcset(url) {
    return WIDTHS.map(function (w) { return sized(url, w) + ' ' + w + 'w'; }).join(', ');
  }

  function findCard(swatch) {
    for (var i = 0; i < CARDS.length; i++) {
      var card = swatch.closest(CARDS[i].card);
      if (card) return { el: card, sel: CARDS[i] };
    }
    return null;
  }

  function closeSizes(card) {
    var selector = card.querySelector('.variant-selector');
    if (selector) {
      selector.classList.remove('is-visible');
      selector.style.display = 'none';
    }
    var quickAdd = card.querySelector('.quick-add-button-wrapper');
    if (quickAdd) quickAdd.classList.remove('is-open');
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest && event.target.closest('.cgt-swatch');
    if (!swatch) return;
    var found = findCard(swatch);
    if (!found || found.el.hasAttribute('data-search-api-card')) return;
    event.preventDefault();
    if (swatch.classList.contains('cgt-swatch--active')) return;

    var card = found.el;
    var sel = found.sel;
    var data = swatch.dataset;
    var template = swatch.nextElementSibling;
    var cardData = template && template.content ? template.content : null;
    var swapped = data.cgtOriginal !== 'true';

    closeSizes(card);

    // Images: first slide = featured, second slide = the product's second image
    var images = [data.cgtImg1, data.cgtImg2 || data.cgtImg1];
    card.querySelectorAll(sel.images).forEach(function (img, index) {
      var url = images[Math.min(index, 1)];
      if (!url) return;
      img.removeAttribute('data-rd-src');
      img.removeAttribute('data-rd-srcset');
      img.setAttribute('srcset', srcset(url));
      img.setAttribute('src', url);
      img.setAttribute('alt', data.cgtTitle || '');
    });

    var title = card.querySelector(sel.title);
    if (title) title.textContent = data.cgtTitle;

    card.querySelectorAll(sel.links).forEach(function (link) {
      link.setAttribute('href', data.cgtUrl);
      if (link.hasAttribute('title')) link.setAttribute('title', data.cgtTitle);
    });

    if (cardData) {
      var overlay = card.querySelector(sel.overlay);
      var overlayHtml = cardData.querySelector('[data-cgt-overlay]');
      if (overlay && overlayHtml) overlay.innerHTML = overlayHtml.innerHTML;

      var sizes = card.querySelector('.variant-selector');
      var sizesHtml = cardData.querySelector('[data-cgt-sizes]');
      if (sizes && sizesHtml) sizes.innerHTML = sizesHtml.innerHTML;
    }

    card.setAttribute('data-product-handle', data.cgtHandle);
    card.setAttribute('data-product-id', data.cgtId);
    card.classList.toggle('product-sold-out', data.cgtAvailable !== 'true');
    card.classList.toggle('cgt-swatched', swapped);

    var quickAdd = card.querySelector('.quick-add-button-wrapper');
    if (quickAdd) {
      // The modal quick shop is rendered for the card's own product only
      var modal = quickAdd.getAttribute('data-quick-add-style') === 'modal';
      quickAdd.classList.toggle('quick-add-hidden', data.cgtHidequickadd === 'true' || (modal && swapped));
    }

    swatch.parentNode.querySelectorAll('.cgt-swatch').forEach(function (other) {
      var active = other === swatch;
      other.classList.toggle('cgt-swatch--active', active);
      other.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  });
})();
